import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormattedMessage, injectIntl, intlShape, FormattedDate, FormattedTime } from 'react-intl'
import { each } from 'lodash'

import { callApi } from '../services/fetchService'
import { loadGlobals } from '../actions'

import DataTable from '../components/DataTable'
import FaIcon from '../components/FaIcon'
import TableButton from '../components/TableButton'

import { Modal, Button, Divider, message } from 'antd'



class MessageModal extends Component {
    
    render() {
        const { item, onOk, onCancel, visible } = this.props

        if (!item) return null

        return (
            <Modal title={<FormattedMessage id="messages.modalTitle" />} visible={visible} onOk={onOk} onCancel={onCancel} closable footer={[
                <Button key="submit" type="primary" onClick={onOk}><FormattedMessage id="misc.close" /></Button>
            ]}>
                <strong><FormattedMessage id="messages.dateColumn" /></strong> : <FormattedDate value={item.date} /> - <FormattedTime value={item.date} /><br />
                <strong><FormattedMessage id="messages.authorColumn" /></strong> : {item.fullName}<br />
                <strong><FormattedMessage id="messages.emailColumn" /></strong> : <a href={"mailto:" + item.email}>{item.email}</a><br /><br />
                <strong><FormattedMessage id="messages.titleColumn" /></strong> : {item.title}<br />
                <Divider />
                {item.message}
            </Modal>
        )
    }
}



class Messages extends Component {

    state = {
        data: [],
        loading: false,
        modalVisible: false,
        modalItem: null
    }

    static propTypes = {
        loadGlobals: PropTypes.func.isRequired,
        intl: intlShape.isRequired
    }

    fetch = (params = {}) => {
        const { intl } = this.props
        this.setState({ loading: true })
        callApi({
            endpoint: 'messages'
        }).then((data) => {
            this.setState({
                data: each(data, (item) => {
                    item.fullName = item.firstName + ' ' + item.lastName
                }),
                loading: false
            })
        }).catch((err) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
            this.setState({ loading: false })
        })
    }

    componentDidMount() {
        this.fetch()
    }

    markAsRead = (record) => {
        const { intl } = this.props
        callApi({
            endpoint: 'messages/' + record.id,
            method: 'POST',
            body: { read: true }
        }).then((data) => {
            message.success(intl.formatMessage({id: 'misc.updateSuccess'}))
            this.fetch()
            this.props.loadGlobals()
        }).catch((data) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
        })
    }

    markAsUnread = (record) => {
        const { intl } = this.props
        callApi({
            endpoint: 'messages/' + record.id,
            method: 'POST',
            body: { read: false }
        }).then((data) => {
            message.success(intl.formatMessage({id: 'misc.updateSuccess'}))
            this.fetch()
            this.props.loadGlobals()
        }).catch((data) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
        })
    }

    delete = (record) => {
        const { intl } = this.props
        callApi({
            endpoint: 'messages/' + record.id,
            method: 'DELETE'
        }).then((data) => {
            message.success(intl.formatMessage({id: 'misc.deleteSuccess'}))
            this.fetch();
            this.props.loadGlobals()
        }).catch((data) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
        })
    }

    rowsConfig = (record) => {
        let config = {
            style: { cursor: 'pointer' },
            onClick: (e) => this.showModal(record)
        }
        if (record.read) config.style.color = 'rgba(0, 0, 0, .25)'
        return config
    }

    /**
     * Modal handling
     */
    showModal = (record) => {
        this.setState({modalVisible: true, modalItem: record})
    }
    closeModal = () => {
        const { modalItem } = this.state
        if (!modalItem.read) {
            this.markAsRead(modalItem)
        }
        this.setState({modalVisible: false, modalItem: null})
    }

    render() {
        const { data, loading, modalVisible, modalItem } = this.state

        const columns = [
            { title: "messages.dateColumn", dataIndex: "date", type: "datetime", sorter: true, defaultSortOrder: "descend" },
            { title: "messages.authorColumn", dataIndex: "fullName", type: "string", sorter: true },
            { title: "messages.titleColumn", dataIndex: "title", type: "string", sorter: true },
            { title: "misc.actions", width: "150px", key: "action", render: (record) => (
                <span>
                {record.read ? 
                    <TableButton color="blue" icon="envelope" onClick={this.markAsUnread} value={record} tip="messages.markAsUnread" />
                    : <TableButton color="green" icon="envelope-open" onClick={this.markAsRead} value={record} tip="messages.markAsRead" />}
                    <a href={"mailto:" + record.email}><TableButton color="blue" icon="reply" tip="messages.reply" /></a>
                    <TableButton color="red" icon="trash-alt" onClick={this.delete} value={record} confirm />
                </span>
            ) }
        ]

        return (
            <div>
                <h1><FaIcon icon="envelope" fixedWidth /> <FormattedMessage id="messages.title" /></h1>
                <MessageModal visible={modalVisible} item={modalItem} onOk={this.closeModal} onCancel={this.closeModal} />
                <DataTable columns={columns} dataSource={data} loading={loading} rowKey="id" size="middle" onRow={this.rowsConfig} />
            </div>
        )
    }

}

export default injectIntl(connect(null, {
    loadGlobals
})(Messages))


// WEBPACK FOOTER //
// ./src/views/Messages.js